// 问题提交列表页
<template>
    <div class="problem-submit-list" v-loading.fullscreen.lock="loading">
        <div class="st-mainbody">
            <div class="container doc-header x-flex x-space-between x-flex-center x-p-t-15 x-p-b-15 x-p-t-50">
                <div>
                    <div class="title">提交建议</div>
                    <div class="subtitle">
                        您可以通过填写表单提交产品的各类问题
                    </div>
                </div>
                <router-link to="/problemSubmit" class=" create-btn x-p-t-10 x-p-b-10 x-p-l-20 x-p-r-20 theme-bgcolor c-f font-sm c-pointer x-flex x-flex-center br-2">
                    <i class="el-icon-plus x-m-r-5 font-md fwb"></i>创建您的问题
                </router-link>
            </div>
            <div class="container doc-search x-flex x-flex-center x-p-t-15 x-p-b-15">
                <div class="font-sm fwb explain">最近提交列表</div>
                <el-input placeholder="请输入您要查询的内容" v-model="searchVal" style="width: 400px" @blur="fSearch">
                    <template slot="append">
                        <div class="x-p-l-40 x-p-r-40 x-p-t-5 x-p-b-5 c-pointer w100p h100p" @click="fSearch">
                            <i class="el-icon-search font-md c-f"></i>
                        </div>
                    </template>
                </el-input>
            </div>
            <div class="container x-m-t-30">
                <el-table v-if="$store.state.userCode && tableData && tableData.length > 0" :data="tableData" style="width: 100%" empty-text=" " @filter-change="fTableFilter"
                    @sort-change="fSortChange">
                    <el-table-column type="index" width="50" align="center"></el-table-column>
                    <el-table-column label="问题编号" width="120" align="center" height="100">
                        <template slot-scope="scope">
                            <span class="theme-color-1 fwb">{{scope.row.id}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="status" label="问题进展" width="130" align="center" :filters="filterStatus" :column-key="'status'" :filter-multiple="true">
                        <template slot-scope="scope">
                            <div class="x-inline-block x-p-t-5 x-p-b-5 x-p-l-15 x-p-r-15"
                                :style="{ 'background-color':  scope.row.status > 0 ? statusData[scope.row.status-1].bgcolor : '#efefef','border-radius': '30px'}"><i
                                    class="el-icon-circle-check x-m-r-5"
                                    :style="{'color': scope.row.status > 0 ? statusData[scope.row.status-1].color : ''}"></i>{{ scope.row.status > 0 ? statusData[scope.row.status-1].text : '其他'}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="product" label="产品类型" width="160" align="center" :filters="filterProduct" :column-key="'product'" :filter-multiple="true"></el-table-column>
                    <el-table-column prop="level" label="紧急程度" width="120" align="center" :filters="filterLevel" :column-key="'level'" :filter-multiple="true">
                        <template slot-scope="scope">
                            <span v-if="scope.row.level == '1'" :class="[scope.row.level == '1' ? 'theme-color-1 fwb' : '']">最高</span>
                            <span v-if="scope.row.level == '2'">较高</span>
                            <span v-if="scope.row.level == '3'">普通</span>
                            <span v-if="scope.row.level == '4'">较低</span>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column prop="user.nickname" label="提交人" width="100" align="center"></el-table-column> -->
                    <el-table-column prop="create_time" label="提交时间" width="180" align="center" sortable></el-table-column>
                    <el-table-column label="提交主题" align="center">
                        <template slot-scope="scope">
                            <span class="theme-color-1 fwb ellipsis-2" v-html="scope.row.title"></span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="lastUser.nickname" label="最后处理人" width="100" align="center"></el-table-column>
                    <el-table-column prop="update_time" label="最后处理时间" width="180" align="center" sortable></el-table-column>
                    <el-table-column prop="date" label="操作" width="90" align="center" fixed="right">
                        <template slot-scope="scope">
                            <router-link :to="'/problemSubmitDetail?id=' + scope.row.id" class="theme-color c-pointer">查看详情</router-link>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="empty-data x-flex x-flex-center x-flex-dir-column x-m-t-100" v-if="tableData.length == 0 || !$store.state.userCode">
                    <img src="../assets/imgs/table-empty-image.png" alt="" width="200px" height="200px">
                    <el-button v-if="!$store.state.userCode" class="el-button--theme x-m-t-30">
                        <router-link to="/login">立即登录</router-link>
                    </el-button>
                    <el-button v-else class="el-button--theme x-m-t-30">
                        <router-link to="/problemSubmit">立即创建问题</router-link>
                    </el-button>
                </div>
            </div>
            <div :class="['container x-m-t-40 x-m-b-100 x-flex x-flex-center x-space-between', tableData.length == 0 ? 'x-bd-t x-p-t-30' : '']">
                <div>{{tableData.length > 0 ? `共${total}条数据` : '0条数据'}}</div>
                <el-pagination background layout="prev, pager, next" :page-size="pagesize" :total="tableData.length > 0 ? total : 0" @current-change="fPageChange"></el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            loading: true,
            searchVal: "", // 搜索框 值
            pagesize: 10,
            total: 0,
            tableData: [],
            filterStatus: [
                { text: "已提交", value: "1" },
                { text: "已受理", value: "2" },
                { text: "已回复", value: "3" },
                { text: "已发布", value: "4" },
                { text: "已关闭", value: "5" },
            ],
            filterProduct: [
                { text: "EDA", value: "EDA" },
                { text: "WAT测试机", value: "WAT测试机" },
                { text: "大数据分析软件", value: "大数据分析软件" },
                { text: "其他", value: "其他" },
            ],
            filterLevel: [
                { text: "最高", value: "1" },
                { text: "较高", value: "2" },
                { text: "普通", value: "3" },
                { text: "较低", value: "4" },
            ],
            statusData: [
                {
                    color: "#E48437",
                    bgcolor: "#FFF4EB",
                    text: "已提交",
                },
                {
                    color: "#0F2FA2",
                    bgcolor: "#EDF1FF",
                    text: "已受理",
                },
                {
                    color: "#B64749",
                    bgcolor: "#FFF5F6",
                    text: "已回复",
                },
                {
                    color: "#B64749",
                    bgcolor: "#EEFFF6",
                    text: "已发布",
                },
                {
                    color: "#8b8b8b",
                    bgcolor: "#f3f3f3",
                    text: "已关闭",
                },
            ],
            productArr: [],
            statusArr: [],
            levelArr: [],
            sortVal: "",
        };
    },
    async created() {
        await this.getProblemData();
    },
    methods: {
        async fTableFilter(filters) {
            if (Array.isArray(filters.status)) {
                this.statusArr = filters.status;
            }
            if (Array.isArray(filters.level)) {
                this.levelArr = filters.level;
            }
            if (Array.isArray(filters.product)) {
                this.productArr = filters.product;
            }
            await this.getProblemData();
        },
        async fSearch() {
            await this.getProblemData();
        },
        async fPageChange(num) {
            await this.getProblemData(num);
        },
        async fSortChange(column) {
            console.log(column);
            if (column.order && column.order.slice(0, 1) == "a") {
                this.sortVal = column.prop + "_" + column.order.slice(0, 3);
            } else if (column.order && column.order.slice(0, 1) == "d") {
                this.sortVal = column.prop + "_" + column.order.slice(0, 4);
            } else {
                this.sortVal = "";
            }
            await this.getProblemData();
        },
        async getProblemData(pageNum = 1) {
            this.loading = true;
            let res = await this.$get("/jsapi/question/query", {
                q: this.searchVal,
                page: pageNum,
                pagesize: this.pagesize,
                product: this.productArr.join(","),
                status: this.statusArr.join(","),
                level: this.levelArr.join(","),
                sort: this.sortVal,
            });
            // console.log(res);
            if (res.code == "200") {
                this.tableData = res.data.list;
                this.total = Number(res.data.total);
            }
            this.loading = false
        },
    },
};
</script>

<style scoped lang='less'>
.problem-submit-list {
    min-height: calc(100vh - 180px);
    .st-mainbody {
        .doc-header {
            .title {
                font-size: 24px;
                font-weight: bold;
            }
            .subtitle {
                font-size: 12px;
                color: #999;
            }
        }
        .doc-search {
            .explain {
                height: 40px;
                padding-right: 25px;
                margin-right: 25px;
                border-right: 1px solid #eee;
                display: flex;
                align-items: center;
            }
        }
    }
    /deep/ .el-input-group__append {
        background-color: #0d288b;
        border: 2px solid #0d288b;
    }
    /deep/ .el-input__inner {
        border: 2px solid #0d288b;
    }
    /deep/ .el-input__inner:focus {
        border: 2px solid #0d288b;
    }
    /deep/ tr {
        // font-weight: bold;
        text-align: center;
        height: 60px;
    }
    /deep/ .el-table__column-filter-trigger i {
        font-size: 16px;
        font-weight: bold;
    }

    /deep/ .el-table::before {
        height: 0 !important;
    }

    /deep/ .el-input-group__append {
        padding: 0;
    }

    // /deep/ .el-table__empty-block{
    //     background-image: url('../assets/imgs/table-empty-image.png');
    //     background-size: contain;
    //     background-position: center center;
    //     background-repeat: no-repeat;
    //     height: 300px !important;
    //     margin: 50px 0 !important;
    //     position: relative;
    // }
    // /deep/ .el-table__empty-text {
    //     position: absolute;
    //     bottom: -10px;
    // }
}
</style>


// WEBPACK FOOTER //
// src/views/ProblemSubmitList.vue